<template>
  <div class="form-group">
    <label
      v-if="titulo != 'hide'"
      v-bind:class="{ 'text-danger': current.errors && current.errors[object] }"
    >
      {{ titulo }}
    </label>
    <v-select
      label="nombre"
      v-model="current[object]"
      :disabled="disabled"
      :filterable="false"
      :options="activos_fijos"
      @search="onSearch"
    >
      <template slot="no-options">Activo Fijo...</template>
      <template slot="option" slot-scope="option">
        <div class="selected d-center">
          {{ option.identificador }} - {{ option.nombre }}
        </div>
      </template>
      <template slot="selected-option" slot-scope="option">
        <div class="selected d-center">
          {{ option.identificador }} - {{ option.nombre }}
        </div>
      </template>
    </v-select>
    <small
      v-if="current.errors && current.errors[object]"
      class="form-text text-danger"
      >{{ current.errors[object][0] }}</small
    >
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    titulo: {
      type: String,
      default: "Activo Fijo",
    },
    disabled: {
      type: Boolean,
    },
    current: {
      type: Object,
      required: true,
    },
    object: {
      type: String,
      default: "activo",
    },
  },
  computed: {
    ...mapGetters({
      activos_fijos: "catalogos/activos_fijos",
    }),
  },
  mounted() {
    this.$store.dispatch("catalogos/activos_fijos", {
      activo: true,
      quitar_paginacion: true,
    });
  },
  methods: {
    onSearch(search, loading) {
      loading(true);
      this.search(loading, search, this);
    },
    search: _.debounce((loading, search, vm) => {
      if (search == "" || search == null) {
        loading(false);
        return;
      }
      let that = this;
      vm.$store.dispatch("catalogos/activos_fijos", {
        page: 1,
        quitar_paginacion: true,
        "filter[search]": search,
      });
      loading(false);
    }, 350),
  },
};
</script>